// extracted by mini-css-extract-plugin
export default {"bodyRight":"ManageMedia_bodyRight__q-m3H"};